module.exports = __webpack_public_path__ + "static/img/manual-20.53829d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/vi/manual-20.png
// module id = oF8x
// module chunks = 4